export type SmartDeepLinkValues =
  | 'Origin'
  | 'Destination'
  | 'OutboundDate'
  | 'ReturnDate'
  | 'AdultsAmount'
  | 'ChildrenAmount'
  | 'InfantsAmount'
  | 'Culture'
  | 'Currency';
export const SmartDeeplinkValues: Record<SmartDeepLinkValues, string> = {
  Origin: 'o',
  Destination: 'd',
  OutboundDate: 'dd',
  ReturnDate: 'rd',
  AdultsAmount: 'adt',
  ChildrenAmount: 'chd',
  InfantsAmount: 'inf',
  Culture: 'c',
  Currency: 'cur'
};
